export const calendarSymbols: string[] = ['•', '†', '‡', '#', '♠', '♦', '♣', '♥'];

export interface CalendarCalloutItem {
  name: string;
  dates: Set<string>;
}
